import { useRef } from 'react';
import { notification as antNotification } from 'antd';
import { getConfFromRef, getTypeConfig } from './notification.conf';
import Text from '@/v2/components/Typography/Text';
import Colors from '@/v2/constants/Colors';

export const notification = {
  success: (props) => open({ type: 'success', ...props }),
  error: (props) => open({ type: 'error', ...props }),
  warning: (props) => open({ type: 'warning', ...props }),
  info: (props) => open({ type: 'info', ...props }),
  close: antNotification.close,
  destroy: antNotification.destroy,
};

export const useNotification = () => {
  const ref = useRef(null);
  return {
    notification,
    ref,
  };
};

function open({ type, message, description, ref, ...props }) {
  let config = {
    ...getTypeConfig(type),
    message: (
      <Text
        aria-label="Notification message"
        variant="dm-16-medium"
        color={Colors.BLACK}
      >
        {message}
      </Text>
    ),
    ...(description && {
      description:
        typeof description === 'string' ? (
          <Text variant="dm-16-medium" color={Colors.BLACK}>
            {description}
          </Text>
        ) : (
          description
        ),
    }),
    ...props,
  };

  if (ref?.current) {
    config = getConfFromRef(config, ref);
  }

  return antNotification.open({ type, ...config });
}
